"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _auth = require("@/utils/auth");

var _constants = require("@/utils/constants");

var _button_widget = _interopRequireDefault(require("@/views/widgets/button_widget.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Button: _button_widget.default
  },
  data: function data() {
    var validateMaxLength = function validateMaxLength(rule, value, callback) {
      if (value.trim() === '' || value === null) {
        callback(new Error(rule.colname + 'を入力してください。'));
      } else if (value.length > rule.maxLen) {
        callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
      } else {
        callback();
      }
    };

    return {
      waitDialogVisible: false,
      addDialogVisible: false,
      userForDelete: false,
      form: {
        roleName: ''
      },
      roleApp: [{
        'name': '個人チャット',
        'val': false,
        'id': 'app_private_chat_create'
      }, {
        'name': 'グループチャット',
        'val': false,
        'id': 'app_group_chat_create'
      }, {
        'name': 'チャットの画像を送信',
        'val': false,
        'id': 'app_allow_chat_image'
      }, {
        'name': 'チャットのファイルを送信',
        'val': false,
        'id': 'app_allow_chat_file'
      }, {
        'name': '組織チャットの編集',
        'val': false,
        'id': 'app_join_affiliation_chat_myself'
      }, {
        'name': 'アプリ内通話',
        'val': false,
        'id': 'app_make_call'
      }, {
        'name': '掲示板の閲覧',
        'val': false,
        'id': 'app_bulletin_board'
      }, {
        'name': '掲示板でのアンケート投票結果の閲覧',
        'val': false,
        'id': 'app_view_private_survey_result'
      }, {
        'name': '目安箱の作成',
        'val': false,
        'id': 'app_suggestion'
      }, {
        'name': '目安箱の画像を送信',
        'val': false,
        'id': 'app_allow_suggestion_image'
      }, {
        'name': '目安箱のファイルを送信',
        'val': false,
        'id': 'app_allow_suggestion_file'
      }, {
        'name': '既読者／未読者の閲覧',
        'val': false,
        'id': 'app_chat_read_view'
      }],
      roleAdmin: [{
        'name': 'ユーザーの登録',
        'val': false,
        'id': 'admin_user_add'
      }, {
        'name': 'ユーザー情報の編集',
        'val': false,
        'id': 'admin_user_edit'
      }, {
        'name': 'ユーザー情報の閲覧',
        'val': false,
        'id': 'admin_user_view'
      }, {
        'name': '掲示板の投稿',
        'val': false,
        'id': 'admin_bulletin_add'
      }, {
        'name': '掲示板のカテゴリーの編集',
        'val': false,
        'id': 'admin_bulletin_category_edit'
      }, {
        'name': '掲示板の編集',
        'val': false,
        'id': 'admin_bulletin_edit'
      }, {
        'name': '掲示板の閲覧',
        'val': false,
        'id': 'admin_bulletin_view'
      }, {
        'name': '目安箱の閲覧',
        'val': false,
        'id': 'admin_suggestion_view'
      }, {
        'name': '目安箱のカテゴリの編集',
        'val': false,
        'id': 'admin_suggestion_category_edit'
      }, {
        'name': '管理サイトのログイン',
        'val': false,
        'id': 'use_admin_site'
      }],
      validateMaxLength: function validateMaxLength(rule, value, callback) {
        if (value.trim() === '' || value === null) {
          callback(new Error(rule.colname + 'を入力してください。'));
        } else if (value.length > rule.maxLen) {
          callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
        } else {
          callback();
        }
      },
      rules: {
        roleName: [{
          required: true,
          validator: validateMaxLength,
          colname: '役割名',
          maxLen: 40
        }]
      }
    };
  },
  computed: {
    roleData: {
      get: function get() {
        return JSON.parse((0, _auth.getUserPermission)());
      }
    }
  },
  watch: {
    $data: {
      deep: true,
      handler: function handler(value) {
        this.listeningStatusUpdateButton(value);
      }
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var dataRoute, roleID, userCount, roleData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dataRoute = this.$route.params.id;

              if (!dataRoute) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return (0, _auth.setIdEditPage)(dataRoute.id);

            case 4:
              _context.next = 6;
              return (0, _auth.getIdEditPage)();

            case 6:
              roleID = _context.sent;
              _context.next = 9;
              return this.$store.dispatch('company/getRoleById', roleID);

            case 9:
              _context.next = 11;
              return this.$store.dispatch('company/getUserCountByRoleId', roleID);

            case 11:
              userCount = _context.sent;

              if (userCount) {
                this.userForDelete = true;
              }

              roleData = this.$store.getters.userRoleByIdList;
              this.form.roleName = roleData.name;
              this.roleApp.filter(function (item) {
                switch (item.id) {
                  case 'app_private_chat_create':
                    item.val = roleData.app_private_chat_create;
                    break;

                  case 'app_group_chat_create':
                    item.val = roleData.app_group_chat_create;
                    break;

                  case 'app_chat_read_view':
                    item.val = roleData.app_chat_read_view;
                    break;

                  case 'app_email':
                    item.val = roleData.app_email;
                    break;

                  case 'app_map':
                    item.val = roleData.app_map;
                    break;

                  case 'app_bulletin_board':
                    item.val = roleData.app_bulletin_board;
                    break;

                  case 'app_custom_app_icon':
                    item.val = roleData.app_custom_app_icon;
                    break;

                  case 'app_make_call':
                    item.val = roleData.app_make_call;
                    break;

                  case 'app_view_private_survey_result':
                    item.val = roleData.app_view_private_survey_result;
                    break;

                  case 'is_default_role':
                    item.val = roleData.is_default_role;
                    break;

                  case 'app_suggestion':
                    item.val = roleData.app_suggestion;
                    break;

                  case 'app_join_affiliation_chat_myself':
                    item.val = roleData.app_join_affiliation_chat_myself;
                    break;

                  case 'app_allow_chat_image':
                    item.val = roleData.app_allow_chat_image;
                    break;

                  case 'app_allow_chat_file':
                    item.val = roleData.app_allow_chat_file;
                    break;

                  case 'app_allow_suggestion_image':
                    item.val = roleData.app_allow_suggestion_image;
                    break;

                  case 'app_allow_suggestion_file':
                    item.val = roleData.app_allow_suggestion_file;
                    break;
                }
              });
              this.roleAdmin.filter(function (item) {
                switch (item.id) {
                  case 'admin_user_add':
                    item.val = roleData.admin_user_add;
                    break;

                  case 'admin_user_edit':
                    item.val = roleData.admin_user_edit;
                    break;

                  case 'admin_user_import':
                    item.val = roleData.admin_user_import;
                    break;

                  case 'admin_user_view':
                    item.val = roleData.admin_user_view;
                    break;

                  case 'admin_bulletin_view':
                    item.val = roleData.admin_bulletin_view;
                    break;

                  case 'admin_bulletin_add':
                    item.val = roleData.admin_bulletin_add;
                    break;

                  case 'admin_bulletin_edit':
                    item.val = roleData.admin_bulletin_edit;
                    break;

                  case 'admin_bulletin_category_edit':
                    item.val = roleData.admin_bulletin_category_edit;
                    break;

                  case 'use_admin_site':
                    item.val = roleData.use_admin_site;
                    break;

                  case 'admin_role_view':
                    item.val = roleData.admin_role_view;
                    break;

                  case 'admin_role_edit':
                    item.val = roleData.admin_role_edit;
                    break;

                  case 'admin_role_add':
                    item.val = roleData.admin_role_add;
                    break;

                  case 'admin_suggestion_view':
                    item.val = roleData.admin_suggestion_view;
                    break;

                  case 'admin_suggestion_category_edit':
                    item.val = roleData.admin_suggestion_category_edit;
                    break;
                }
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    goToIndex: function goToIndex() {
      this.$router.replace({
        name: 'RoleIndex'
      });
    },
    listeningStatusUpdateButton: function () {
      var _listeningStatusUpdateButton = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(value) {
        var isHistory, historyValue, isChanged;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _auth.getHistoryDataFromPage)();

              case 2:
                isHistory = _context2.sent;
                historyValue = value.roles.map(function (item) {
                  return item.val;
                });
                isChanged = JSON.stringify("".concat(value.form.inputDialog).concat(historyValue));
                if (isHistory !== isChanged) this.disableButton = false;else this.disableButton = true;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function listeningStatusUpdateButton(_x) {
        return _listeningStatusUpdateButton.apply(this, arguments);
      }

      return listeningStatusUpdateButton;
    }(),
    handleDialogValidate: function handleDialogValidate() {
      var _this = this;

      this.$refs['form'].validate(
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee3(valid) {
          var questionYesOrNo;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!valid) {
                    _context3.next = 7;
                    break;
                  }

                  _context3.next = 3;
                  return (0, _constants.message_box_confirm)('確認', '権限情報を更新します。よろしいですか？', '更新', 'message_default');

                case 3:
                  questionYesOrNo = _context3.sent;

                  if (questionYesOrNo) {
                    _this.handleOnAdd();
                  }

                  _context3.next = 9;
                  break;

                case 7:
                  _this.log('error submit!!');

                  return _context3.abrupt("return", false);

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleOnAdd: function () {
      var _handleOnAdd = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var roleApp, roleAdmin, findItemRoleApp, findItemRoleAdmin, dataRoles, result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                findItemRoleAdmin = function _ref3(value) {
                  var roleItem = roleAdmin.filter(function (item) {
                    return item.id === value.toString().trim();
                  });

                  if (roleItem.length !== 0) {
                    return roleItem[0].val;
                  } else {
                    return false;
                  }
                };

                findItemRoleApp = function _ref2(value) {
                  var roleItem = roleApp.filter(function (item) {
                    return item.id === value.toString().trim();
                  });

                  if (roleItem.length !== 0) {
                    return roleItem[0].val;
                  } else {
                    return false;
                  }
                };

                this.addDialogVisible = false;
                roleApp = this.roleApp;
                roleAdmin = this.roleAdmin;
                dataRoles = {
                  id: (0, _auth.getIdEditPage)(),
                  roles: {
                    name: this.form.roleName.toString().trim(),
                    app_private_chat_create: findItemRoleApp('app_private_chat_create'),
                    app_affiliation_direct_chat: true,
                    app_bulletin_board: findItemRoleApp('app_bulletin_board'),
                    app_chat_read_view: findItemRoleApp('app_chat_read_view'),
                    app_make_call: findItemRoleApp('app_make_call'),
                    app_group_chat_create: findItemRoleApp('app_group_chat_create'),
                    app_view_private_survey_result: findItemRoleApp('app_view_private_survey_result'),
                    app_suggestion: findItemRoleApp('app_suggestion'),
                    app_join_affiliation_chat_myself: findItemRoleApp('app_join_affiliation_chat_myself'),
                    admin_bulletin_add: findItemRoleAdmin('admin_bulletin_add'),
                    admin_bulletin_category_edit: findItemRoleAdmin('admin_bulletin_category_edit'),
                    admin_bulletin_edit: findItemRoleAdmin('admin_bulletin_edit'),
                    admin_bulletin_view: findItemRoleAdmin('admin_bulletin_view'),
                    admin_user_add: findItemRoleAdmin('admin_user_add'),
                    admin_user_edit: findItemRoleAdmin('admin_user_edit'),
                    admin_user_view: findItemRoleAdmin('admin_user_view'),
                    use_admin_site: findItemRoleAdmin('use_admin_site'),
                    admin_suggestion_view: findItemRoleAdmin('admin_suggestion_view'),
                    admin_suggestion_category_edit: findItemRoleAdmin('admin_suggestion_category_edit'),
                    app_allow_chat_image: findItemRoleApp('app_allow_chat_image'),
                    app_allow_chat_file: findItemRoleApp('app_allow_chat_file'),
                    app_allow_suggestion_image: findItemRoleApp('app_allow_suggestion_image'),
                    app_allow_suggestion_file: findItemRoleApp('app_allow_suggestion_file')
                  }
                };
                _context4.next = 8;
                return this.$store.dispatch('company/updateRoles', dataRoles).catch(function (error) {
                  _this2.$notify({
                    title: 'エラー',
                    message: '役割の更新に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });

                  console.log(error);
                });

              case 8:
                result = _context4.sent;

                if (result) {
                  this.$notify({
                    title: '情報',
                    message: '役割の更新が完了しました。',
                    type: 'success',
                    duration: 2000
                  });
                  this.$router.replace({
                    name: 'RoleIndex'
                  });
                }

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleOnAdd() {
        return _handleOnAdd.apply(this, arguments);
      }

      return handleOnAdd;
    }(),
    handleDeleteItem: function () {
      var _handleDeleteItem = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;

        var questionYesOrNo, roleID, result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.enableDialogVisible = false;
                _context5.next = 3;
                return (0, _constants.message_box_confirm)('確認', 'この役割を削除すると全ての所属している社員は役割が無くなります。よろしいですか？', '削除', 'message_delete');

              case 3:
                questionYesOrNo = _context5.sent;

                if (!questionYesOrNo) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 7;
                return (0, _auth.getIdEditPage)();

              case 7:
                roleID = _context5.sent;
                _context5.next = 10;
                return this.$store.dispatch('company/deleteRoleById', roleID).catch(function (error) {
                  _this3.$notify({
                    title: 'エラー',
                    message: '役割の削除に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });

                  console.log(error);
                  throw error;
                });

              case 10:
                result = _context5.sent;

                if (result) {
                  this.$notify({
                    title: '情報',
                    message: '役割の削除が完了しました。',
                    type: 'success',
                    duration: 2000
                  });
                  this.$router.replace({
                    name: 'RoleIndex'
                  });
                }

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleDeleteItem() {
        return _handleDeleteItem.apply(this, arguments);
      }

      return handleDeleteItem;
    }()
  }
};
exports.default = _default;